module.exports = __webpack_public_path__ + "static/media/unibestMv1.d18d28a6.png";